module.exports = __webpack_public_path__ + "img/ico-profile.97b5b2e0.svg";